export default __webpack_public_path__ + "static/atom-c7a474c65dd6b441997d21a3dbb6fb8c.webp";